module.exports = __webpack_public_path__ + "static/fonts/iconfont.773e346.woff";


//////////////////
// WEBPACK FOOTER
// ./src/iconfont/iconfont.woff?t=1766389844018
// module id = RK1k
// module chunks = 169